import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import {
  CurrentState,
  LoadAllAnimalsAction,
  LoadAllLotsAction,
  RanchesActionTypes,
  SetSelectedRanchIdAction
} from "common-lib";
import { PortalAppState } from "../reducer";
import { PortalBaseEffects } from "../portalBaseEffects";


@Injectable()
export class PortalLivestockEffects extends PortalBaseEffects {

  loadAllAnimalsAfterSelectedRanchChanged: Observable<Action>;
  loadAllLots: Observable<Action>;

  constructor(protected currentState: CurrentState<PortalAppState>,
              protected store: Store<PortalAppState>,
              private actions: Actions) {
    super(currentState);

    this.loadAllAnimalsAfterSelectedRanchChanged = createEffect(() => this.actions.pipe(
      ofType(RanchesActionTypes.SET_SELECTED_RANCH_ID),
      map((action: SetSelectedRanchIdAction) => {
        return action.payload
      }),
      switchMap((payload) => {
        return of(new LoadAllAnimalsAction(payload));
      })
    ));

    this.loadAllLots = createEffect(() => this.actions.pipe(
      ofType(RanchesActionTypes.SET_SELECTED_RANCH_ID),
      switchMap(() => {
        return of(new LoadAllLotsAction());
      })
    ));
  }
}
